import instance, { CRM_REPORT_API_URL } from 'api';
import { AxiosRequestConfig } from 'axios';
import qs from 'qs';
import { IPartnerRatingByRealEstate } from './interfaces';

export const getPartnerRatingByRealEstate = async (config?: AxiosRequestConfig) => {
  return instance(true, CRM_REPORT_API_URL)
    .get<{ list: IPartnerRatingByRealEstate[]; totalCount: number }>('/partner/rating/listByRealEstate', {
      ...config,
      paramsSerializer: (params) => qs.stringify(params, { allowDots: true, arrayFormat: 'repeat', skipNulls: true }),
    })
    .then((response) => response.data);
};

export const exportPartnerRatingByRealEstateExcelReport = async (config?: AxiosRequestConfig) => {
  return instance(true, CRM_REPORT_API_URL)
    .get<Blob>('/partner/rating/listByRealEstate/export', {
      ...config,
      paramsSerializer: (params) => qs.stringify(params, { allowDots: true, arrayFormat: 'repeat', skipNulls: true }),
      responseType: 'blob',
    })
    .then((response) => response.data);
};
